import { ROUTE_PATH } from 'common/constants/sm-constants';
import {
  FormMetaModel,
  SmMetaFileModel,
} from 'common/models/utility-models/meta-model';

export class UploadDocumentMetaModel extends FormMetaModel {
  constructor() {
    super('', ROUTE_PATH.uploadDocument, ROUTE_PATH.uploadDocument, 1);
  }
  override initProperties(): any {
    const formInfo = super.initProperties();
    // const uploadDocFile = new SmMetaFileModel(
    //   'uploadDocFile',
    //   'uploadDocFile',
    //   'file',
    //   false,
    //   'col-12 col-lg-6 col-md-6',
    //   4,
    //   7,
    //   '',
    //   'singleimagepreview',
    //   '',
    //   false,
    //   true,
    //   true,
    //   false,
    //   0,
    //   0,
    //   false,
    //   ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
    //   3000,
    //   250,
    //   510,
    //   'image',
    //   'upload_document',
    //   false,
    //   false,
    //   2000,
    //   3000
    // );

    const uploadRemaining: any = [];
    const allDocsUploaded: boolean = true;
    const uploadedImage: File | null = null;
    const fileError: any = '';
    const filePath: string | ArrayBuffer | null = null;
    const isLinkExpired:boolean = false;
    return {
      formInfo,
      uploadRemaining,
      allDocsUploaded,
      uploadedImage,
      fileError,
      filePath,
      isLinkExpired
      //uploadDocFile
    };
  }
}

export class uploadDocument {
  applicant_id: number;
  documentTypeId: number;
  uploadDocFile: any;
}
